export default "__VITE_ASSET__EYJcpxnr__"